<template>
<div class="">
     <div :class="'no-flight-wrapper-depart'"
          
          show
          color="danger"
        ><img src="@/assets/mf/img/gif/nothing-found.gif" alt="">
        <!-- No Hotels for these Route -->
            <!-- <div v-if="isNoFlights==false && from!=null && to!=null">{{$t('flightResults.cEmptyFlightRes.noFlightsFrom')+' '+from+' '+$t('flightResults.cEmptyFlightRes.to')+' '+to}}</div> -->
             <div v-if="isNoFlights==true && from==null && to==null">{{'There are no hotels' }}</div>
             <div v-if="isNoFlights==false && from==null && to==null">{{'There are no hotels for applied filters'}}</div>
            </div>
            </div>

            
</template>
<script>
import BaseConfiguration from "../../../../config/base.js";
    import {
        COMPONENT_NAME,
        PATHNAME,
       
    } from "../../../../util/constants";
import { mapGetters, mapActions } from "vuex";
export default {
 name: 'cEmptyHotelRes',
        props: {
            from:{
                type: String
            },
            to:{
                type: String
            },
            isNoFlights: {
                type: Boolean
            }
        },   
}
</script>